import React, { memo } from 'react';
import styled from 'styled-components';

const About = () => (
  <ContentWrapper>
    <TextBlock>
      <Paragraph>Hi there ! </Paragraph>
      <Paragraph>This is a small application that was mainly developed for myself.</Paragraph>
      <Paragraph> Later some other 2 - 3 people wanted to use it so now it&apos;s online.</Paragraph>
      <Paragraph> By now you probably guessed that it has something to do with time management and you are correct.</Paragraph>
      <Paragraph>
        I was looking online for a simple app with a simple interface that would allow me to track the time I spend
        while working on something.
      </Paragraph>
      <Paragraph> There are a few sites that do this but they either want you to pay or register for an account.</Paragraph>
      <Paragraph> Not this one. Let me list some of the key features of chroniker.co :</Paragraph>
      <OrderedList>
        <ListItem> Free </ListItem>
        <ListItem>  Simple interface </ListItem>
        <ListItem>
          {' '}
          No registration required. In fact, no personal data is collected except the traffic details
          that are used by google analytics.
        </ListItem>
        <ListItem>  Works offline. Yes you can use it with no internet, it&apos;s magic, believe me.</ListItem>
        <ListItem>
          {' '}
          Might &quot;work&quot; as a standalone desktop or mobile app. Chroniker is built as a progressive web application,
          that means that you can install it on your phone or on your computer.
        </ListItem>
        <ListItem>
          {' '}
          Stores everything in your browser cache. No information is sent to any server,
          it&apos;s all here on your machine, try it, refresh the homepage.
        </ListItem>
        <ListItem>  It can send you notifications at fixed time intervals (even on your phone) if you need that sort of thing.</ListItem>
        <ListItem> Dark Mode </ListItem>
      </OrderedList>
      <Paragraph> That&apos;s about it!</Paragraph>
      <Paragraph>
        You might be thinking &quot;Ok cool, dark mode is nice&quot;,
        and then click away to get back to whatever you were doing before this.
      </Paragraph>
      <Paragraph>
        But now you will leave knowing that there&apos;s this small website that makes it extremely
        easy to manage your time or just take some notes.
      </Paragraph>
      <Paragraph>
        In case you do come back, and you like the small improvements I make, then here is a way you can support me.
      </Paragraph>
      <Paragraph>
        I like coffee but I try to avoid it.
        <LinkWrapper href="https://www.buymeacoffee.com/rbreahna" target="_blank" rel="noopener noreferrer">Pizza</LinkWrapper>
        {' '}
        however is an entirely different story.
        <EmoticonWrapper role="img" aria-label="smile">☺</EmoticonWrapper>
      </Paragraph>
    </TextBlock>
  </ContentWrapper>
);

const ContentWrapper = styled.div`
  font-family: Roboto;
  font-weight: 300;
  margin: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: ${(props) => props.theme.media.sm}){
    margin: 40px 4% 20px 4%;
   }
`;

const TextBlock = styled.div`
  width: 60%;
  color: ${(props) => props.theme.main.fontColor};
  @media screen and (max-width: ${(props) => props.theme.media.sm}){
    width: 92%;
   }
`;

const Paragraph = styled.p`
  line-height: 2em;
`;

const OrderedList = styled.ol`
  line-height: 2em;
`;

const ListItem = styled.li`

`;

const EmoticonWrapper = styled.span`
font-size: large;
`;

const LinkWrapper = styled.a`
  text-decoration: underline;
  font-weight: normal;
  &:link{
    color: ${(props) => props.theme.main.fontColor};
  }
  &:visited{
    color: ${(props) => props.theme.main.fontColor};
  }
  &:hover{
  text-decoration: underline;
    color: ${(props) => props.theme.main.fontColor};
  }
`;

export default memo(About);
